import React from 'react';
import { Section } from './ui/Section';
export function OpeningHook() {
  return <Section bg="white" data-id="element-171">
      <div className="prose prose-lg md:prose-xl mx-auto text-center" data-id="element-172">
        <p className="text-xl md:text-2xl font-medium leading-relaxed text-[#78350F]" data-id="element-173">
          Imagina llegar a casa después de un día agotador, abrir la nevera, y
          en vez de encontrarte con sobras aburridas, tener una base maestra
          lista para transformarse en tacos dorados, una sopa relámpago, o
          incluso un wrap fresco.{' '}
          <strong className="text-[#EA580C] font-bold" data-id="element-174">
            Tres cenas distintas, un solo esfuerzo.
          </strong>
        </p>
        <div className="w-24 h-1 bg-[#F59E0B] mx-auto my-8 rounded-full opacity-50" data-id="element-175"></div>
        <p className="text-lg md:text-xl leading-relaxed text-[#78350F]" data-id="element-176">
          Este no es un recetario más. Es un sistema probado por mamás solteras
          reales que no quieren pasarse el domingo entero cocinando. Aquí
          aprenderás a usar el método{' '}
          <strong className="text-[#422006]" data-id="element-177">“Base + 3”</strong> para dominar el
          caos de las 6:00 PM, sin culpas y sin comida repetida.
        </p>
      </div>
    </Section>;
}